import { Component, OnInit } from '@angular/core';
import { DispoService } from '../../services/dispos/dispo.service';
import { FYI_THEADS } from 'src/app/shared/constants';

@Component({
	selector: 'app-fyi-dispos',
	templateUrl: './fyi-dispos.component.html',
	styleUrls: ['./fyi-dispos.component.scss'],
})
export class FyiDisposComponent implements OnInit {
	public tableConfig = {
		tableClass: 'table-striped table-hover',
		theadClass: 'thead-dark',
		dblclickRows: true,
	};

	public buttons = [];
	public dispos = [];

	public theads = FYI_THEADS;

	constructor(private dispoService: DispoService) {}

	ngOnInit() {
		this.dispoService.get_fyi_dispos().subscribe((data: any) => {
			this.dispos = data.body;
		});
	}
}
